import $ from 'jquery'
import AirDatepicker from 'air-datepicker'

// eslint-disable-next-line no-undef
const i18n = bookingHub

// eslint-disable-next-line no-undef
class BhubElementorAvailability extends elementorModules.frontend.handlers
  .Base {
  constructor(...args) {
    super(...args)
  }
  getYmd(month, year) {
    const date = new Date()

    date.setFullYear(year, month, 1)

    const formattedYear = date.getFullYear()
    const formattedMonth = ('0' + (date.getMonth() + 1)).slice(-2)
    const formattedDay = '01'

    return formattedYear + '-' + formattedMonth + '-' + formattedDay
  }
  getDefaultSettings() {
    return {
      selectors: {
        formSelector: '.bhub-availability',
        daterangeSelector: '.bhub-availability__daterange',
      },
    }
  }
  getDefaultElements() {
    const selectors = this.getSettings('selectors')
    return {
      $daterangeSelector: this.$element.find(selectors.daterangeSelector),
      $formSelector: this.$element.find(selectors.formSelector),
    }
  }
  bindEvents() {
    this.elements.$daterangeSelector.on(
      'change',
      this.dateInputChange.bind(this)
    )

    this.disabledDays = this.elements.$daterangeSelector
      .data('disabled-days')
      .map((date) => {
        return new Date(date)
      })

    this.loadCalendar()
    this.listenOtherForms()
  }
  dateInputChange() {}
  listenOtherForms() {
    const that = this

    $(document).on('bhubDaterangeSelect', function (e, data) {
      if (data.from === 'bookingForm') {
        that.datePicker.selectDate(data.datePicker.selectedDates, {
          silent: true,
        })
      }
    })
  }
  loadCalendar() {
    this.datePicker = this.initCalendar(
      this.elements.$daterangeSelector.get(0),
      this.disabledDays
    )
  }
  getDates(ymd = '') {
    const form = this.elements.$formSelector
    const service = form.attr('data-service')
    const product = form.attr('data-room')

    return new Promise((resolve, reject) => {
      $.ajax({
        url: i18n.ajaxUrl,
        method: 'POST',
        dataType: 'json',
        data: {
          action: 'bhub/shortcode/get_dates',
          service,
          room_id: product,
          nonce: i18n.nonce,
          date: ymd,
        },
        success: function (response) {
          if (response.success) {
            const formattedDays = response.data.disabledDays.map((date) => {
              return new Date(date)
            })

            resolve(formattedDays)
          } else {
            reject(response.data.message)
          }
        },
      })
    })
  }
  initCalendar(el, disabledDays) {
    const that = this
    const classes = this.elements.$formSelector.attr('data-id')

    return new AirDatepicker(el, {
      classes: `bhub-airdatepicker bhub-${classes}`,
      locale: i18n.calendar.i18n,
      dateFormat: 'yyyy-MM-dd',
      range: true,
      inline: true,
      firstDay: i18n.firstDayOfTheWeek * 1,
      toggleSelected: false,
      showOtherMonths: false,
      selectOtherMonths: false,
      fixedHeight: true,
      minDate: new Date(),
      multipleDatesSeparator: ' - ',
      onChangeViewDate: ({ month, year }) => {
        const ymd = that.getYmd(month, year)
        that.date = ymd

        this.getDates(ymd)
          .then((disabledDays) => {
            that.datePicker.disableDate(disabledDays)
          })
          .catch((err) => {
            console.error(err)
          })
      },
      onRenderCell: ({ date, cellType, datepicker }) => {
        if ('day' !== cellType) return
        if (date.getMonth() !== datepicker.viewDate.getMonth()) return

        const isDisabled = disabledDays.some(
          (disabledDate) =>
            date.toLocaleDateString() === disabledDate.toLocaleDateString()
        )

        if (isDisabled) {
          return {
            disabled: true,
          }
        }
      },
      onSelect: ({ formattedDate, datepicker }) => {
        if (formattedDate.length > 1) {
          this.daterange = formattedDate
          if (window.bhubRoomDatePicker) {
            window.bhubRoomDatePicker.selectDate(datepicker.selectedDates)
          }
          $(el).trigger('change')
        }
      },
    })
  }
}

$(window).on('elementor/frontend/init', () => {
  const addHandler = ($element) => {
    // eslint-disable-next-line no-undef
    elementorFrontend.elementsHandler.addHandler(BhubElementorAvailability, {
      $element,
    })
  }

  // eslint-disable-next-line no-undef
  elementorFrontend.hooks.addAction(
    'frontend/element_ready/bhub-realtime-availability.default',
    addHandler
  )
})
